import { BlocRepliable } from './BlocRepliable';
import {
  resumerDroitImage,
  type SaisieDroitImage,
  type SaisieEtatSupport,
} from '../lib/droitImage';

const ETATS: { code: SaisieEtatSupport; libelle: string }[] = [
  { code: '', libelle: 'Non renseigné' },
  { code: 'accorde', libelle: 'Accordé' },
  { code: 'refuse', libelle: 'Refusé' },
];

/**
 * DROIT A L'IMAGE dans le formulaire d'adherent : UN etat — non
 * renseigne (le defaut), accorde, refuse — d'apres le papier signe
 * (une seule dimension depuis la 0.67.0, decision de Georges). Date de
 * signature et commentaire. Replie par defaut, la ligne de titre resume
 * l'etat.
 */
export function ChampDroitImage({
  valeur,
  onChanger,
  anneeLibelle,
  verrouille,
}: {
  valeur: SaisieDroitImage;
  onChanger: (valeur: SaisieDroitImage) => void;
  anneeLibelle: string | null;
  /** Annee cloturee : l'autorisation ne se pose ni ne se retire plus (RG-27). */
  verrouille?: boolean;
}) {
  return (
    <BlocRepliable titre="Droit à l’image" resume={resumerDroitImage(valeur)}>
      <fieldset disabled={verrouille} className="space-y-3">
        <div className="flex flex-wrap gap-4 text-sm">
          {ETATS.map((etat) => (
            <label key={etat.code} className="flex items-center gap-1">
              <input
                type="radio"
                name="droit-image-etat"
                checked={valeur.etat === etat.code}
                onChange={() => onChanger({ ...valeur, etat: etat.code })}
              />
              {etat.libelle}
            </label>
          ))}
        </div>

        <div className="grid gap-3 sm:grid-cols-3">
          <label className="block">
            <span className="text-xs text-encre-500">Signée le</span>
            <input
              type="date"
              className="champ mt-1"
              value={valeur.dateSignature}
              onChange={(e) => onChanger({ ...valeur, dateSignature: e.target.value })}
            />
          </label>
          <label className="block sm:col-span-2">
            <span className="text-xs text-encre-500">Commentaire</span>
            <input
              className="champ mt-1"
              value={valeur.commentaire}
              onChange={(e) => onChanger({ ...valeur, commentaire: e.target.value })}
              placeholder="Signée par la mère…"
              maxLength={500}
            />
          </label>
        </div>

        <p className="text-xs text-encre-400">
          D’après le papier signé, qui reste au secrétariat. L’autorisation se renouvelle chaque
          année{anneeLibelle ? ` — ici sur ${anneeLibelle}` : ''}.
        </p>
      </fieldset>
    </BlocRepliable>
  );
}
